var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 40,
    viewBox: "0 0 132 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_584)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.109 40H4.89069C2.19522 40 0 37.7456 0 35V5C0 2.24439 2.19522 0 4.89069 0H127.109C129.802 0 132 2.24439 132 5V35C132 37.7456 129.802 40 127.109 40Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.109 0.800499C129.37 0.800499 131.221 2.68828 131.221 5V35C131.221 37.3117 129.382 39.1995 127.109 39.1995H4.89069C2.6299 39.1995 0.779499 37.3117 0.779499 35V5C0.779499 2.68828 2.61776 0.800499 4.89069 0.800499H127.109ZM127.109 0H4.89069C2.19522 0 0 2.25436 0 5V35C0 37.7556 2.19522 40 4.89069 40H127.109C129.802 40 132 37.7556 132 35V5C132 2.25436 129.802 0 127.109 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5377 13.2319C68.6562 13.2319 67.9131 12.9152 67.3255 12.2917C66.7427 11.6858 66.4173 10.8504 66.4318 9.99748C66.4318 9.08726 66.733 8.31669 67.3255 7.70571C67.9107 7.08227 68.6538 6.76556 69.5352 6.76556C70.407 6.76556 71.1501 7.08227 71.7475 7.70571C72.34 8.33664 72.6411 9.10721 72.6411 9.99748C72.6314 10.9102 72.3303 11.6808 71.7475 12.2893C71.1622 12.9177 70.4192 13.2319 69.5377 13.2319ZM43.3093 13.2319C42.4472 13.2319 41.6993 12.9202 41.0874 12.3042C40.4803 11.6908 40.1719 10.9152 40.1719 9.99998C40.1719 9.08477 40.4803 8.30921 41.0874 7.69574C41.6872 7.07978 42.4351 6.76806 43.3093 6.76806C43.7367 6.76806 44.1519 6.85534 44.5502 7.0324C44.9411 7.20447 45.2592 7.43888 45.4948 7.72566L45.5531 7.79798L44.895 8.46132L44.827 8.37903C44.4554 7.92517 43.9576 7.70322 43.2996 7.70322C42.7119 7.70322 42.1995 7.91768 41.777 8.34162C41.352 8.76806 41.1359 9.32666 41.1359 10.0025C41.1359 10.6783 41.352 11.2369 41.777 11.6633C42.1995 12.0873 42.7119 12.3017 43.2996 12.3017C43.9261 12.3017 44.453 12.0873 44.8634 11.6633C45.1062 11.4139 45.2568 11.0648 45.3102 10.6234H43.2V9.69075H46.216L46.2281 9.77554C46.25 9.93265 46.2718 10.0947 46.2718 10.2444C46.2718 11.1047 46.0193 11.8005 45.5191 12.3142C44.9508 12.9227 44.2078 13.2319 43.3093 13.2319ZM78.1825 13.0997H77.2525L74.404 8.41893L74.4283 9.26182V13.0972H73.4983V6.90023H74.5595L74.5886 6.94761L77.267 11.3566L77.2428 10.5162V6.90023H78.1825V13.0997ZM62.5489 13.0997H61.6067V7.8329H59.9725V6.90023H64.1808V7.8329H62.5465V13.0997H62.5489ZM59.2051 13.0997H58.2654V6.90023H59.2051V13.0997ZM53.9235 13.0997H52.9837V7.8329H51.3495V6.90023H55.5578V7.8329H53.9235V13.0997ZM50.7545 13.0898H47.1509V6.90023H50.7545V7.8329H48.0931V9.53364H50.4947V10.4563H48.0931V12.1571H50.7545V13.0898ZM68.0151 11.6509C68.4352 12.0823 68.9452 12.2992 69.5377 12.2992C70.1472 12.2992 70.645 12.0873 71.0602 11.6509C71.4731 11.2269 71.6819 10.6708 71.6819 9.99998C71.6819 9.32916 71.4731 8.77055 71.0627 8.34911C70.6426 7.91768 70.1302 7.70073 69.5401 7.70073C68.9306 7.70073 68.4328 7.9127 68.02 8.34911C67.6072 8.77305 67.3983 9.32916 67.3983 9.99998C67.3983 10.6708 67.6047 11.2294 68.0151 11.6509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3446 21.7556C64.0498 21.7556 62.1897 23.5436 62.1897 26.0099C62.1897 28.4538 64.062 30.2643 66.3446 30.2643C68.6394 30.2643 70.4995 28.4638 70.4995 26.0099C70.4995 23.5436 68.6394 21.7556 66.3446 21.7556ZM66.3446 28.5785C65.0891 28.5785 64.0085 27.5112 64.0085 26C64.0085 24.4663 65.0916 23.4214 66.3446 23.4214C67.6001 23.4214 68.6807 24.4663 68.6807 26C68.6831 27.5212 67.6001 28.5785 66.3446 28.5785ZM57.2796 21.7556C54.9848 21.7556 53.1247 23.5436 53.1247 26.0099C53.1247 28.4538 54.9969 30.2643 57.2796 30.2643C59.5744 30.2643 61.4345 28.4638 61.4345 26.0099C61.4345 23.5436 59.5719 21.7556 57.2796 21.7556ZM57.2796 28.5785C56.0241 28.5785 54.9435 27.5112 54.9435 26C54.9435 24.4663 56.0266 23.4214 57.2796 23.4214C58.535 23.4214 59.6156 24.4663 59.6156 26C59.6156 27.5212 58.535 28.5785 57.2796 28.5785ZM46.4929 23.0548V24.8553H50.7012C50.5725 25.8653 50.2471 26.6109 49.7493 27.1222C49.1325 27.7556 48.1806 28.4438 46.5026 28.4438C43.9164 28.4438 41.8936 26.2992 41.8936 23.6433C41.8936 20.9875 43.9164 18.8429 46.5026 18.8429C47.8989 18.8429 48.9163 19.4089 49.6716 20.1321L50.9149 18.8553C49.8658 17.8229 48.4695 17.0324 46.5123 17.0324C42.9645 17.0324 39.9873 20 39.9873 23.6334C39.9873 27.2768 42.962 30.2344 46.5123 30.2344C48.4282 30.2344 49.8658 29.591 51.0023 28.379C52.1606 27.1895 52.5273 25.5112 52.5273 24.1571C52.5273 23.7356 52.4957 23.3566 52.4302 23.0349H46.4904C46.4929 23.0324 46.4929 23.0548 46.4929 23.0548ZM90.6135 24.4563C90.2663 23.5012 89.2172 21.7456 87.0657 21.7456C84.9336 21.7456 83.1609 23.4688 83.1609 26C83.1609 28.389 84.9142 30.2543 87.2721 30.2543C89.1662 30.2543 90.2687 29.0648 90.7228 28.3665L89.3168 27.399C88.8505 28.1097 88.2022 28.576 87.2818 28.576C86.3518 28.576 85.701 28.1421 85.2687 27.2867L90.8078 24.9301C90.8078 24.9326 90.6135 24.4563 90.6135 24.4563ZM84.9652 25.8778C84.9215 24.2344 86.2085 23.399 87.1288 23.399C87.8549 23.399 88.4596 23.7655 88.666 24.2992L84.9652 25.8778ZM80.4655 30H82.2843V17.5012H80.4655V30ZM77.4786 22.7007H77.413C77.0026 22.1995 76.2231 21.7456 75.2275 21.7456C73.161 21.7456 71.2572 23.6134 71.2572 26.0124C71.2572 28.4015 73.1513 30.2468 75.2275 30.2468C76.211 30.2468 77.0026 29.7905 77.413 29.2793H77.4786V29.8902C77.4786 31.5137 76.6335 32.389 75.2712 32.389C74.1566 32.389 73.4645 31.566 73.1828 30.8778L71.602 31.5561C72.0561 32.6783 73.2678 34.0673 75.2688 34.0673C77.4009 34.0673 79.2076 32.778 79.2076 29.6334V22H77.4883V22.7007C77.4907 22.7007 77.4786 22.7007 77.4786 22.7007ZM75.3902 28.5785C74.1347 28.5785 73.0857 27.5012 73.0857 26.0124C73.0857 24.5112 74.1347 23.4239 75.3902 23.4239C76.6335 23.4239 77.5976 24.5236 77.5976 26.0124C77.6097 27.5012 76.6359 28.5785 75.3902 28.5785ZM99.1297 17.5012H94.7806V30H96.5994V25.2668H99.1322C101.145 25.2668 103.124 23.768 103.124 21.389C103.124 19.0099 101.153 17.5012 99.1297 17.5012ZM99.1832 23.5212H96.597V19.2319H99.1832C100.545 19.2319 101.315 20.3865 101.315 21.3765C101.315 22.3566 100.536 23.5212 99.1832 23.5212ZM110.414 21.7331C109.093 21.7331 107.731 22.3341 107.168 23.6433L108.78 24.3316C109.127 23.6434 109.763 23.4089 110.436 23.4089C111.378 23.4089 112.33 23.9875 112.352 25.0199V25.1521C112.027 24.9626 111.313 24.6733 110.458 24.6733C108.717 24.6733 106.951 25.6508 106.951 27.4837C106.951 29.1621 108.379 30.2394 109.97 30.2394C111.191 30.2394 111.864 29.6733 112.284 29.0174H112.35V29.985H114.103V25.197C114.103 22.9675 112.491 21.7331 110.414 21.7331ZM110.186 28.5785C109.591 28.5785 108.758 28.2793 108.758 27.5112C108.758 26.5436 109.797 26.177 110.684 26.177C111.485 26.177 111.864 26.3541 112.34 26.5985C112.209 27.7207 111.286 28.5685 110.186 28.5785ZM120.499 22L118.411 27.4214H118.345L116.182 22H114.224L117.471 29.5785L115.621 33.7905H117.515L122.51 22H120.499ZM104.127 30H105.946V17.5012H104.127V30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1602 7.53367C9.87852 7.84539 9.71582 8.3217 9.71582 8.94514V31.0574C9.71582 31.6808 9.87852 32.1571 10.1699 32.4564L10.2452 32.5237L22.3092 20.1347V19.8579L10.2355 7.46634L10.1602 7.53367Z",
    fill: "url(#paint0_linear_31_584)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3234 24.2768L22.2996 20.1446V19.8553L26.3234 15.7232L26.4108 15.778L31.1704 18.5561C32.5327 19.3441 32.5327 20.6459 31.1704 21.4439L26.4108 24.2219L26.3234 24.2768Z",
    fill: "url(#paint1_linear_31_584)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4109 24.2219L22.2997 20L10.1604 32.4663C10.6048 32.9551 11.3503 33.01 12.1832 32.5337L26.4109 24.2219Z",
    fill: "url(#paint2_linear_31_584)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4109 15.7781L12.1832 7.47882C11.3503 6.99004 10.6024 7.05737 10.1604 7.54615L22.2997 20L26.4109 15.7781Z",
    fill: "url(#paint3_linear_31_584)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3231 24.1322L12.1925 32.3766C11.4033 32.8429 10.6991 32.8105 10.245 32.3865L10.1697 32.4638L10.245 32.5312C10.6991 32.9526 11.4033 32.9875 12.1925 32.5212L26.4203 24.222L26.3231 24.1322Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1704 21.2993L26.3113 24.1322L26.3987 24.2219L31.1583 21.4439C31.8406 21.0449 32.1757 20.5212 32.1757 20C32.1344 20.4788 31.7872 20.9327 31.1704 21.2993Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.183 7.62345L31.1703 18.7008C31.7871 19.0574 32.1343 19.5237 32.1877 20C32.1877 19.4788 31.8526 18.9551 31.1703 18.5561L12.183 7.47881C10.8207 6.67831 9.71582 7.34664 9.71582 8.94514V9.08978C9.71582 7.48878 10.8207 6.83292 12.183 7.62345Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_584",
    x1: 21.2271,
    y1: 8.70657,
    x2: 1.83606,
    y2: 13.7378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_584",
    x1: 32.9469,
    y1: 20,
    x2: 9.3847,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_584",
    x1: 24.1754,
    y1: 22.2973,
    x2: 8.04448,
    y2: 48.7348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31_584",
    x1: 7.10359,
    y1: 0.178806,
    x2: 14.3004,
    y2: 11.9864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.1067b486da82f5446dcc2e617a6c1c95.svg";
export { ForwardRef as ReactComponent };